import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: 'root',
})
export class SuperAdminSubjectService {
	private selectValueSubject = new BehaviorSubject<string>("0");
	
	public getSubject() {
		return this.selectValueSubject;
	}

	public setSubject(value: string) {
		this.selectValueSubject.next(value);
	}
}